import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    // changing text should update it without reloading page
    this.element.textContent = 'Hello World7!';
  }
}
